import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import { listPaginationLoaderDeps } from '../../list/pagination/list-pagination-loader-deps.ts';
import type { processDefinitionsTemplateQuery } from '../../process-definitions-template/__generated__/processDefinitionsTemplateQuery.graphql.ts';
import relayReq from '../../process-definitions-template/__generated__/processDefinitionsTemplateQuery.graphql.ts';
import type { processDefinitionsTemplateQueryFragment$data } from '../../process-definitions-template/__generated__/processDefinitionsTemplateQueryFragment.graphql.ts';
import { ProcessDefinitionsTemplate } from '../../process-definitions-template/process-definitions-template.tsx';
import { processDefinitionsTemplateSearchSchema } from '../../process-definitions-template/process-definitions-template-search-schema.ts';
import { relayEnv } from '../../relay/relay-env.ts';

type TProcessDefinitionTemplateKeys =
    keyof processDefinitionsTemplateQueryFragment$data['content'][number];

export const Route = createFileRoute('/_index/process-definitions-template')({
    component: ProcessDefinitionsTemplate,
    // errorComponent: () => <div>err</div>,
    loaderDeps: ({ search: { pageNum, pageSize, search, sortBy, sortDir } }) => ({
        ...listPaginationLoaderDeps(pageNum, pageSize),
        search,
        sortBy,
        sortDir,
    }),
    loader: (ctx) => {
        const searchBy: TProcessDefinitionTemplateKeys[] = [
            'id',
            'definitionKey',
            'definitionName',
            'definitionVersion',
        ];
        return loadQuery<processDefinitionsTemplateQuery>(
            relayEnv,
            relayReq,
            {
                ...ctx.deps,
                searchBy,
                filter: { siteUrl: { eq: ctx.context.site?.siteUrl }, status: { eq: 'TEMPLATE' } },
            },
            { fetchPolicy: 'store-and-network' }
        );
    },
    validateSearch: processDefinitionsTemplateSearchSchema,
});
